import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useBoundStore } from 'app/store';
import { CallGuideModal } from 'shared/ui';

import ReadonlyField from './ReadonlyField';
import { UpdateLink } from './UpdateLink';

// 제출 시 환자정보 상태에서 redirectUrl 사용 해 해당 페이지로 이동
export const ReadonlyFormContainer = ({ Title }) => {
  const navigate = useNavigate();
  const {
    usrNm,
    usrBirthday,
    usrTelNo,
    postNo,
    bscAddr,
    dtlAddr,
    actualPostNo,
    actualBscAddr,
    actualDtlAddr,
    custCtrTelNo,
    usrTelNoUdpYn,
    usrAddrUdpYn,
  } = useBoundStore((state) => state['hsptlzForm'].patientInfoData);
  const [openCallGuideModal, setOpenCallGuideModal] = useState(false);

  const handleCallGuideModal = () => {
    setOpenCallGuideModal(false);
  };

  return (
    <>
      <ReadonlyField>
        <ReadonlyField.NameAndBirth usrNm={usrNm} usrBirthday={usrBirthday} />
        <ReadonlyField.TelList usrTelNo={usrTelNo} />
        <ReadonlyField.Address title='주소' postNo={postNo} bscAddr={bscAddr} dtlAddr={dtlAddr} />
        {actualPostNo && (
          <ReadonlyField.Address
            title={
              <>
                <>
                  실제
                  <br />
                  거주지
                  <br />
                  주소
                </>
              </>
            }
            postNo={actualPostNo}
            bscAddr={actualBscAddr}
            dtlAddr={actualDtlAddr}
          />
        )}
      </ReadonlyField>
      <UpdateLink
        onClick={() => {
          if (usrTelNoUdpYn === 'Y' || usrAddrUdpYn === 'Y') navigate('/hsptlz/form/user-form');
          else setOpenCallGuideModal(true);
        }}
      />
      {openCallGuideModal && (
        <CallGuideModal
          title='등록된 정보 변경을 원하시나요?'
          subTitle={`지금 보고 계신 개인정보는 병원에 저장된 정보예요.
                변경을 원하실 경우 병원 콜센터로 직접 문의해 주세요.`}
          btnText='닫기'
          telNumber={custCtrTelNo}
          handleClose={handleCallGuideModal}
        />
      )}
    </>
  );
};

